import { Box, Grid, IconButton, Stack, Typography } from "@mui/material";
import { AddRounded, RemoveRounded } from "@mui/icons-material";
import {
  arrowBgColor,
  blackColor,
  greenColor08,
  greyShade51,
  greyShade53,
  headingColor,
  orangeColor01,
  whiteColor,
} from "../../configs/styles/muiThemes";

function QuantityPicker({ count, onIncrement, onDecrement, minQty, maxQty }) {
  return (
    <Stack>
      <Box sx={styles.quantityPicker}>
        <Grid container direction="row" alignItems="center">
          <Grid item>
            <Box
              sx={[
                styles.qtBtn,
                {
                  borderRight: {
                    md: "1px solid " + blackColor,
                    xs: "1px solid " + greenColor08,
                  },
                  border: "",
                },
              ]}
              onClick={onDecrement}
            >
              <RemoveRounded
                sx={{
                  // color: count <= minQty ? arrowBgColor : headingColor,
                  color: whiteColor,
                  fontSize: "16px",
                }}
              />
            </Box>
          </Grid>

          {/* <Divider orientation='vertical' flexItem /> */}

          <Grid item>
            <Typography
              variant="body1"
              color={whiteColor}
              fontSize="12px"
              width="30px"
              fontWeight={600}
              textAlign="center"
            >
              {count}
            </Typography>
          </Grid>

          {/* <Divider orientation='vertical' flexItem sx={{backgroundColor: primaryColor}} /> */}

          <Grid item onClick={onIncrement}>
            <Box
              sx={[
                styles.qtBtn,
                {
                  borderLeft: {
                    md: "1px solid " + blackColor,
                    xs: "1px solid " + greenColor08,
                  },
                  border: "",
                },
              ]}
            >
              <AddRounded
                sx={{
                  color: count >= maxQty ? whiteColor : whiteColor,
                  fontSize: "16px",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
}

export default QuantityPicker;

const styles = {
  quantityPicker: {
    width: "75px",
    height: "28px",
    borderRadius: 1.5,
    backgroundColor: { md: blackColor, xs: greenColor08 },
    border: { md: "1px solid " + blackColor, xs: "1px solid " + greenColor08 },
    overflow: "hidden",
  },

  qtBtn: {
    width: "21px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
};
